// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SO-z","twoColumnImage":"TO-z"};